import * as React from 'react';

type PageScrollStyles = {
  bodyOverflow: string;
  bodyPaddingRight: string;
  documentElementOverflow: string;
};

let activePageScrollLocks = 0;
let pageScrollStylesBeforeLock: PageScrollStyles | undefined;

const getPageScrollStyles = (): PageScrollStyles => ({
  bodyOverflow: document.body.style.overflow,
  bodyPaddingRight: document.body.style.paddingRight,
  documentElementOverflow: document.documentElement.style.overflow,
});

const restorePageScrollStyles = (styles: PageScrollStyles): void => {
  document.documentElement.style.overflow = styles.documentElementOverflow;
  document.body.style.overflow = styles.bodyOverflow;
  document.body.style.paddingRight = styles.bodyPaddingRight;
};

const getScrollbarWidth = (): number => {
  return window.innerWidth - document.documentElement.clientWidth;
};

const getBodyPaddingRight = (): number => {
  return parseInt(window.getComputedStyle(document.body).paddingRight, 10) || 0;
};

const applyPageScrollLock = (): void => {
  const scrollbarWidth = getScrollbarWidth();

  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';

  if (scrollbarWidth > 0) {
    document.body.style.paddingRight = `${
      getBodyPaddingRight() + scrollbarWidth
    }px`;
  }
};

const releasePageScrollLock = (): void => {
  activePageScrollLocks = Math.max(activePageScrollLocks - 1, 0);

  if (activePageScrollLocks > 0 || !pageScrollStylesBeforeLock) {
    return;
  }

  restorePageScrollStyles(pageScrollStylesBeforeLock);
  pageScrollStylesBeforeLock = undefined;
};

const acquirePageScrollLock = (): (() => void) => {
  if (activePageScrollLocks === 0) {
    pageScrollStylesBeforeLock = getPageScrollStyles();
    applyPageScrollLock();
  }

  activePageScrollLocks += 1;

  return releasePageScrollLock;
};

export const usePageScrollLock = (isLocked: boolean): void => {
  React.useEffect(() => {
    if (!isLocked) {
      return undefined;
    }

    return acquirePageScrollLock();
  }, [isLocked]);
};
